import React from 'react'

function Education() {
  return (
    <div className='Education'>
      Education
    </div>
  )
}

export default Education